import React from 'react';
import './ContactUs.css';

import facultyPhoto from '../assets/prof_rubana_khan.png'; 

const ContactUs = () => {
  return (
    <div className="contact-us-container" id="contact">
      <h1 className="contact-title">Contact Us</h1>
      <div className="contact-card">
        <div className="profile-pic-container">
          <img src={facultyPhoto} alt="Faculty Sponsor" className="profile-pic" />
        </div>
        <div className="contact-details">
          <h2>Prof. Rubana Khan</h2>
          <p>Faculty Sponsor</p>
          <p>PCE ACM STUDENT CHAPTER</p>
          <p>+91 9923350611</p>
          <p>
            <a href="mailto:rubi.tarannum@gmail.com">rubi.tarannum@gmail.com</a>
          </p>
        </div>
      </div>
      <div className="help-box">
        <h3>We Are Here to Help!</h3>
        <p>Feel free to reach out for any inquiries or support. We're always ready to assist you!</p>
      </div>
    </div>
  );
};

export default ContactUs;